import { _, removeClasses, makeGtmCall, closestEl } from '../utils.js'

class Tabs {
    constructor() {
        window.addEventListener('hashchange', this.triggerFromHash)

        document.addEventListener('click', (e) => {
            if (e.target && e.target.dataset.element === 'tab-trigger') {
                e.preventDefault()
                this.changeHash(e.target)
            }
        })
        this.triggerFromHash()
    }
    /**
     * @param  {object} el
     */

    changeHash = (el) => {
        const hash = el.getAttribute('href') || ''
        history.pushState(null, null, `${hash}`)
        this.triggerFromHash()
    }

    triggerFromHash = () => {
        const hashEls = [
            ...document.querySelectorAll(_('tab-trigger', 'element').str()),
        ]

        if (window.location.hash === '' || !hashEls.length) {
            return false
        }

        hashEls.map((el) => {
            if (el.getAttribute('href') === window.location.hash) {
                this.toggleTabs(el)
            }
        })
    }

    /**
     * @param  {object} el
     */

    toggleTabs = (el) => {
        const currentTab = el
        const tabsContainer = closestEl(_('tabs').node(), el)
        const activeTabClass = tabsContainer.querySelector(
            _('tab-trigger', 'element').str(),
        ).dataset.class
        const select = _('tab-select', 'element').nodeFrom(tabsContainer)

        const isTabOpen = currentTab.classList.contains(activeTabClass)
        if (isTabOpen) {
            return false
        }
        const tabTarget = currentTab.getAttribute('href')
        const tabName = currentTab.dataset.tabName
        const tabs = [
            ...tabsContainer.querySelectorAll(
                _('tab-trigger', 'element').str(),
            ),
        ]
        const tabContents = [
            ...tabsContainer.querySelectorAll(
                _('tab-container', 'element').str(),
            ),
        ]
        const activeTabContentClass = tabsContainer.querySelector(
            _('tab-container', 'element').str(),
        ).dataset.class

        currentTab.dataset.gtmEvent = 'tab-open'
        currentTab.dataset.gtmName = tabName ? tabName : tabTarget
        makeGtmCall(el)

        removeClasses(tabs, activeTabClass)
        removeClasses(tabContents, activeTabContentClass)

        currentTab.classList.add(activeTabClass)

        // Some tabs dont have a data-tab-name so we need to use the old logic
        if (tabName) {
            select.innerHTML = tabName
        } else {
            const selectName = currentTab.dataset.gtmName
                .replace('#', '')
                .replace('-', ' ')
                .replace('_', ' ')
            select.innerHTML =
                selectName.charAt(0).toUpperCase() + selectName.substr(1)
        }
        document.querySelector(tabTarget).classList.add(activeTabContentClass)
    }
}
export default Tabs
